//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ZapisSpecialistCard',
  props: {
    specialist: {},
    selectedId: {}
  },
  emits: ['changeSpecialist'],
  components: {
    ZapisSpecialistInfoPopup: () => import('~/components/zapis/ZapisSpecialistInfoPopup.vue'),
  },
  data: function () {
    return {
      isOpenPopup: false,
    }
  },
  computed: {
    isSelectedCard: function () {
      return this.specialist.id === this.selectedId;
    }
  },
  methods: {
    changeOption: function (selectSpecialist) {
      this.$emit("changeSpecialist", selectSpecialist);
    },
    openSpecialistPopup: function (item) {
      this.isOpenPopup = true;
    },
    closeSpecialistPopup: function () {
      this.isOpenPopup = false;
    }
  }
}
